// Common Loader

import React, { useEffect } from "react";
import {
  View,
  ActivityIndicator,
  Dimensions,
  StyleSheet,
  BackHandler,
  Text,
  TouchableOpacity,
} from "react-native";
import { connect } from "react-redux";
import Width from "../../assets/Width";
import {globalConfigurableData} from "../../utils/globalConstant";

let { height, width } = Width;

const Loader = React.memo((props) => {
  useEffect(() => {
    //adding event for hardware back button.
    var backHandler;
    if (props.loader) {
      backHandler = BackHandler.addEventListener("hardwareBackPress", () => {
        return true;
      });
    } else {
      backHandler && backHandler.remove();
    }

    return () => {
      // removing hardware back event when component unmounts.
      backHandler && backHandler.remove();
    };
  }, [props.loader]);
  return props.loader ? (
    <TouchableOpacity style={[styles.container]} activeOpacity={1}>
      <ActivityIndicator size="large" color={globalConfigurableData.loaderColor} />
    </TouchableOpacity>
  ) : null;
});

const mapStateToProps = (state) => ({
  loader: state.LoaderReducer.loader,
});
export default connect(mapStateToProps)(Loader);

const styles = StyleSheet.create({
  container: {
    // flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    position: "absolute",
    zIndex: 1111,
    top: 0,
    left: 0,
    height,
    width,
  },
});
